import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { CVV_TOOLTIP_TEST_ID, QUESTION_CIRCLE_FILL_ICON_TEST_ID } from './constants';
import { QuestionCircleFillIcon } from '@chegg-ui/horizon-icons';
import { colors } from '@chegg-ui/theme';
import { CVVSubcontainer, CVVContainer, CVVSubheading, CVVImage, StyledLargeTooltip } from './styled';
import { CVV_SUBHEADING_VISA, CVV_SUBHEADING_AMEX, FOUR_DIGIT_CODE, CVV_SUBCONTAINER_VISA_TEST_ID, CVV_SUBCONTAINER_AMEX_TEST_ID, FIND_YOUR_CVV, VISA_CARD_ALT_TEXT, AMEX_CARD_ALT_TEXT, THREE_DIGIT_CODE } from './constants';
import useScreenBreakpoints, { ScreenSize } from '../../hooks/useScreenBreakpoint';
import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { getPaymentFieldLabelText } from './helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';

// Deprecate cloudinary in favor of marketing assets
var VISA_CARD_URL = 'https://marketing-assets.chegg.com/ZYPTD8JS/at/swvg3wb9r9xm3jqv7nhxch/Visa.svg?auto=webp&format=png';
var AMEX_CARD_URL = 'https://marketing-assets.chegg.com/ZYPTD8JS/at/kr83k3bsh8spvm4tkr9gnr6/Amex.svg?auto=webp&format=png';
var subheadingHeight = '0.969rem';
var CVVTooltip = function CVVTooltip() {
  var config = useAppSelector(configSelector);
  var paymentForm = config.paymentForm;
  var rioNamespace = config.rioNamespace;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTooltipVisible = _useState2[0],
    setTooltipVisibility = _useState2[1];
  var screenSize = useScreenBreakpoints();
  var handleQuestionCircleClick = function handleQuestionCircleClick() {
    setTooltipVisibility(function (isTooltipVisible) {
      return !isTooltipVisible;
    });
  };
  var isOpened = screenSize === ScreenSize.PHONE || screenSize === ScreenSize.TABLET ? isTooltipVisible : undefined;
  var trackTooltipShown = function trackTooltipShown() {
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.COMPONENT.NAME.CVV.TOOLTIP'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  };
  return /*#__PURE__*/React.createElement(StyledLargeTooltip, {
    className: "cvv_tooltip",
    "data-test": CVV_TOOLTIP_TEST_ID,
    title: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.FIND_YOUR_CVV) || FIND_YOUR_CVV,
    position: 'bottomLeft',
    open: isOpened,
    targetElement: /*#__PURE__*/React.createElement(QuestionCircleFillIcon, {
      svgColor: colors.grey600,
      size: "small",
      "data-test": QUESTION_CIRCLE_FILL_ICON_TEST_ID,
      onClick: handleQuestionCircleClick
    }),
    onTooltipShown: trackTooltipShown
  }, /*#__PURE__*/React.createElement(CVVContainer, null, /*#__PURE__*/React.createElement(CVVSubcontainer, {
    "data-test": CVV_SUBCONTAINER_VISA_TEST_ID
  }, /*#__PURE__*/React.createElement(CVVSubheading, {
    height: subheadingHeight
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CVV_SUBHEADING_VISA) || CVV_SUBHEADING_VISA), /*#__PURE__*/React.createElement(CVVSubheading, {
    height: subheadingHeight
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.THREE_DIGIT_CODE) || THREE_DIGIT_CODE), /*#__PURE__*/React.createElement(CVVImage, null, /*#__PURE__*/React.createElement("img", {
    src: VISA_CARD_URL,
    alt: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.VISA_CARD_ALT_TEXT) || VISA_CARD_ALT_TEXT
  }))), /*#__PURE__*/React.createElement(CVVSubcontainer, {
    "data-test": CVV_SUBCONTAINER_AMEX_TEST_ID
  }, /*#__PURE__*/React.createElement(CVVSubheading, {
    height: subheadingHeight
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CVV_SUBHEADING_AMEX) || CVV_SUBHEADING_AMEX), /*#__PURE__*/React.createElement(CVVSubheading, {
    height: subheadingHeight
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.FOUR_DIGIT_CODE) || FOUR_DIGIT_CODE), /*#__PURE__*/React.createElement(CVVImage, null, /*#__PURE__*/React.createElement("img", {
    src: AMEX_CARD_URL,
    alt: getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.AMEX_CARD_ALT_TEXT) || AMEX_CARD_ALT_TEXT
  })))));
};
export default CVVTooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentForm/CVVTooltip.js
// module id = 1503
// module chunks = 11